import {createSelector} from 'reselect';
import DisabledCheckoutPageCalls from '../../../../enums/DisabledCheckoutPageCalls';
import {getDisabledCheckoutPageCalls} from '../../getDisabledCheckoutPageCalls';
import {getSettings} from '../../selectors';
import {getPaymentOptions} from '../PaymentOptionSelectors';

export default createSelector(
  [getSettings, getPaymentOptions, getDisabledCheckoutPageCalls],
  (settings, paymentOptions, disabledCheckoutPageCalls) => {
    // Override setting should only be used for testing in stable or on a session in live
    if (settings.override_adyen_v2_enabled) return true;
    
    return (paymentOptions?.some(option => option.type === 'ADYEN_V2')
      && !disabledCheckoutPageCalls.includes(DisabledCheckoutPageCalls.ADYEN_V2_KILLSWITCH));
  },
);
